export default {
  en: {
    label: 'Link Yandex or VK',
    open: 'Open the web version',
    // Справа от строки, когда вход уже привязан: им и заходить в браузере.
    yandex: 'Yandex',
    vk: 'VK',
    hint: 'You’ll link this Telegram account with your progress and subscription. Relinking is only possible through support.',
    hintLinked: 'Open {{host}} in any browser and sign in with {{provider}} — progress and subscription are shared.',
  },
  ru: {
    label: 'Привязать Яндекс или VK',
    open: 'Открыть веб-версию',
    yandex: 'Яндекс',
    vk: 'VK',
    hint: 'Ты привяжешь этот Telegram‑аккаунт с прогрессом и подпиской. Перепривязать можно только через поддержку.',
    hintLinked: 'Открой {{host}} в любом браузере и войди через {{provider}} — прогресс и подписка общие.',
  },
};
